import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStepForwards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStepForwards"><Path d="M17.5 3.5L20.5 6.5L17.5 9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20 6.5H9.5C6.18629 6.5 3.5 9.18629 3.5 12.5C3.5 15.8137 6.18629 18.5 9.5 18.5H18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStepForwards;
